import React from "react";
import { StyledViewOption, StyledViewToggle } from "./studyPaths.styles";

/**
 * "Study Phases | Re-arrange" segmented toggle (SPEC1 R1) — adapts the StyledViewToggle/
 * StyledViewOption pattern from Programs.js's AP-1211 Standard/QA View toggle.
 * @param {"table"|"re-arrange"} props.mode Current query-string `type` value.
 * @param {(mode: "table"|"re-arrange") => void} props.onChange
 * @param {boolean} [props.rearrangeDisabled] Disables the Re-arrange option, e.g. when there are no phases to reorder yet.
 * @param {string} [props.rearrangeDisabledReason] Tooltip shown while the Re-arrange option is disabled.
 */
function StudyPhasesToggle({ mode, onChange, rearrangeDisabled = false, rearrangeDisabledReason }) {
    return (
        <StyledViewToggle role="tablist" aria-label="Study phases view">
            <StyledViewOption
                type="button"
                role="tab"
                aria-selected={mode === "table"}
                $active={mode === "table"}
                onClick={() => onChange("table")}
            >
                Study Phases
            </StyledViewOption>
            <StyledViewOption
                type="button"
                role="tab"
                aria-selected={mode === "re-arrange"}
                $active={mode === "re-arrange"}
                onClick={() => onChange("re-arrange")}
                disabled={rearrangeDisabled}
                title={rearrangeDisabled ? rearrangeDisabledReason : undefined}
            >
                Re-arrange
            </StyledViewOption>
        </StyledViewToggle>
    );
}

StudyPhasesToggle.displayName = "StudyPhasesToggle";

export default StudyPhasesToggle;
